import styled, { useTheme } from 'styled-components';

import { TariffDirection } from '../api/Optimise';

const StyledWrapper = styled.div`
  background: ${(props) =>
    props.direction === TariffDirection.IMPORT
      ? props.theme.colors.gradients.imported
      : props.theme.colors.gradients.exported};
  width: 60px;
  height: 60px;
  min-width: 60px;
  min-height: 60px;
  padding: 5px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const EnergyIcon = ({ direction }) => {
  const theme = useTheme();

  return (
    <StyledWrapper direction={direction}>
      <img src={direction === TariffDirection.IMPORT ? theme.icons.import : theme.icons.export} />
    </StyledWrapper>
  );
};

export default EnergyIcon;
